import { connect } from "react-redux";
import { Creators, getMessage } from "../../reducer";
import Message from "./Message";

export default connect(
  state => ({
    message: getMessage(state)
  }),
  dispatch => ({
    onClearMessage: () => dispatch(Creators.clearMessage())
  })
)(Message);



// WEBPACK FOOTER //
// ./src/customer/components/Message/index.js